import * as React from "react";

/**
 * Quando o menu lateral vira GAVETA (Sheet aberto pelo botão "Toggle Sidebar")
 * em vez de ficar fixo ao lado do conteúdo.
 *
 * Por que não basta o `useIsMobile` (largura < 768): celular DEITADO tem 800–932
 * px de largura e só ~360–430 px de altura. Pela largura ele é "desktop", e o
 * menu fixo (~256 px) comia um terço da tela — o quadro de leads ficava com
 * meia coluna visível (achado de 16/10/2026, 800×364). O critério da gaveta é:
 *
 *   - largura < 768 px (o mesmo corte do `useIsMobile`), OU
 *   - ponteiro grosso (toque) E altura ≤ 500 px — celular deitado.
 *
 * Tablet (iPad 1024×768, 768 px de altura) e desktop não mudam: a altura passa
 * de 500 px, e mouse não é ponteiro grosso.
 *
 * O `useIsMobile` global NÃO muda: ele troca tabela↔cartão em várias telas, e
 * deitado o conteúdo largo continua cabendo.
 */
export const SIDEBAR_DRAWER_MAX_WIDTH = 767;
export const SIDEBAR_DRAWER_MAX_HEIGHT_TOUCH = 500;

export const SIDEBAR_DRAWER_QUERY =
  `(max-width: ${SIDEBAR_DRAWER_MAX_WIDTH}px), ` +
  `(pointer: coarse) and (max-height: ${SIDEBAR_DRAWER_MAX_HEIGHT_TOUCH}px)`;

/** Critério puro (o mesmo da media query), para teste e para quem já tem as medidas. */
export function sidebarComoGaveta(tela: { largura: number; altura: number; toque: boolean }): boolean {
  if (tela.largura <= SIDEBAR_DRAWER_MAX_WIDTH) return true;
  return tela.toque && tela.altura <= SIDEBAR_DRAWER_MAX_HEIGHT_TOUCH;
}

function lerAgora(): boolean {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") return false;
  return window.matchMedia(SIDEBAR_DRAWER_QUERY).matches;
}

export function useSidebarAsDrawer(): boolean {
  const [gaveta, setGaveta] = React.useState<boolean>(lerAgora);

  React.useEffect(() => {
    if (typeof window.matchMedia !== "function") return;
    const mql = window.matchMedia(SIDEBAR_DRAWER_QUERY);
    const onChange = () => setGaveta(mql.matches);
    onChange();
    mql.addEventListener("change", onChange);
    return () => mql.removeEventListener("change", onChange);
  }, []);

  return gaveta;
}
